import Icon from 'veui/components/Icon'

Icon.register({
  'chevron-double-left': {
    paths: [
      {
        d: 'M25.41 2.59a2 2 0 010 2.82L6.83 24 25.4 42.59a2 2 0 01-2.82 2.82l-20-20a2 2 0 010-2.82l20-20a2 2 0 012.82 0zm19 0a2 2 0 010 2.82L25.83 24 44.4 42.59a2 2 0 01-2.82 2.82l-20-20a2 2 0 010-2.82l20-20a2 2 0 012.82 0z'
      }
    ],
    width: '48',
    height: '48'
  }
})
